import { S as Swiper } from './swiper-core-ByDrI-gt.js';
import { N as Navigation } from './navigation-DPDJI5vY.js';
import { A as A11y } from './a11y-bPVd604S.js';
import './create-element-if-not-defined-IE-ZpU9U.js';

class ShopTheLook extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.25,
      spaceBetween: 1,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 1.75,
        },
        1024: {
          slidesPerView: 1.25,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
